/// <reference path="DOMAttached.js" />

class GNOMPetImageBox extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.el.zIndex = 300;
		this.link = options.link;

		if (this.link != "") {
			this.safeObserve(this.el, 'click', this.onClick.bind(this));
			this.safeObserve(this.el, 'mouseover', this.onMouseOver.bind(this));
			this.el.classList.add('clickable');
		}
	}

	onClick(ev) {
		GenericSoundsInstance.pickUpSound();
		this.el.closest('.GNOMApplication').querySelector('.popupContainer').attachedObj.showPopup(this.link);
	}

	onMouseOver(ev) {}
}
